import { BlockType, DSRFormDataItem } from './types'
import {
  ConditionalFieldData,
  ConditionFieldType
} from '../../../../components/ConditionalLogic/conditionalTypes'
import { DEFAULT_LANGUAGE } from '../../../../constants'
import { DsrRequestType } from '../../../../services/graphqlSchemaTypes'
import {
  DsrForm,
  dsrFormElementsWithOptions,
  DsrFormElementTypes,
  DsrFormFieldElement,
  DsrRequestTypes,
  mapDsrRequestTypeKeysToKeys
} from '../../dsrForms/dsrFormsSlice'
import * as uuid from 'uuid'

export const getInitialConfig = (): DSRFormDataItem[] => [
  { type: BlockType.ADD_CONDITION },
  { type: BlockType.CONNECTOR },
  {
    type: BlockType.STEP_EMAIL_ID_VERIFICATION,
    data: {
      id: uuid.v4(),
      enabled: true,
      type: BlockType.STEP_EMAIL_ID_VERIFICATION
    }
  },
  { type: BlockType.CONNECTOR },
  { type: BlockType.ADD_CONDITION },
  { type: BlockType.CONNECTOR },
  {
    type: BlockType.STEP_REQUEST_APPROVAL,
    data: { id: uuid.v4(), enabled: true, type: BlockType.STEP_REQUEST_APPROVAL }
  },
  { type: BlockType.CONNECTOR },
  { type: BlockType.ADD_CONDITION },
  { type: BlockType.CONNECTOR },
  {
    type: BlockType.STEP_DATA_DISCOVERY_VALIDATION,
    data: { id: uuid.v4(), enabled: true, type: BlockType.STEP_DATA_DISCOVERY_VALIDATION }
  },
  { type: BlockType.CONNECTOR },
  { type: BlockType.ADD_CONDITION },
  { type: BlockType.CONNECTOR },
  {
    type: BlockType.STEP_REPORT_GENERATION,
    data: {
      id: uuid.v4(),
      enabled: true,
      type: BlockType.STEP_REPORT_GENERATION
    }
  }
]

export const INITIAL_CONFIG = [
  { type: BlockType.ADD_CONDITION },
  { type: BlockType.CONNECTOR },
  {
    type: BlockType.STEP_EMAIL_ID_VERIFICATION,
    data: {
      id: uuid.v4(),
      enabled: true,
      type: BlockType.STEP_EMAIL_ID_VERIFICATION
    }
  },
  { type: BlockType.CONNECTOR },
  { type: BlockType.ADD_CONDITION },
  { type: BlockType.CONNECTOR },
  {
    type: BlockType.STEP_REQUEST_APPROVAL,
    data: { id: uuid.v4(), enabled: true, type: BlockType.STEP_REQUEST_APPROVAL }
  },
  { type: BlockType.CONNECTOR },
  { type: BlockType.ADD_CONDITION },
  { type: BlockType.CONNECTOR },
  {
    type: BlockType.STEP_DATA_DISCOVERY_VALIDATION,
    data: { id: uuid.v4(), enabled: true, type: BlockType.STEP_DATA_DISCOVERY_VALIDATION }
  },
  { type: BlockType.CONNECTOR },
  { type: BlockType.ADD_CONDITION },
  { type: BlockType.CONNECTOR },
  {
    type: BlockType.STEP_REPORT_GENERATION,
    data: {
      id: uuid.v4(),
      enabled: true,
      type: BlockType.STEP_REPORT_GENERATION
    }
  }
]

interface DsrWorkflowConditionalFieldData extends ConditionalFieldData {
  data?: {
    elementType: DsrFormElementTypes
  }
}

export const getDsrWorkflowFieldsData = (props: {
  forms: DsrForm[]
  requestType?: DsrRequestType
  formLanguage?: string
}): DsrWorkflowConditionalFieldData[] => {
  const { forms, requestType, formLanguage = '' } = props

  const fieldsData: ConditionalFieldData[] =
    forms
      .filter((form) =>
        form.requestType?.includes(mapDsrRequestTypeKeysToKeys(requestType) as DsrRequestTypes)
      )
      .map((form) => {
        const { name, formJsonParsed } = form
        return [
          ...(formJsonParsed?.dataSubjectDetails || []),
          ...(formJsonParsed?.additionalDetails || [])
        ]
          .map((field: DsrFormFieldElement) => {
            const fieldLabel =
              field.i18Labels && field.i18Labels?.[formLanguage]
                ? field.i18Labels?.[formLanguage]
                : field.i18Labels?.[DEFAULT_LANGUAGE] || field.label || ''

            return {
              id: field.id,
              fieldName: fieldLabel,
              sectionName: name,
              values: (Array.isArray(field.value)
                ? field.value
                : [field.value]) as ConditionalFieldData['values'],
              type: dsrFormElementsWithOptions.includes(field.elementType)
                ? ConditionFieldType.select
                : ConditionFieldType.input,
              rules: [],
              options: field.options
                ?.filter((opt) => opt?.value)
                .map((option) => {
                  const optionLabel =
                    option.i18Labels && option.i18Labels?.[formLanguage]
                      ? option.i18Labels?.[formLanguage]
                      : option.i18Labels?.[DEFAULT_LANGUAGE] || option.value || ''
                  return {
                    id: option.id,
                    value: option.value,
                    selected: option?.selected,
                    text: optionLabel
                  }
                }),
              data: {
                elementType: field.elementType
              }
            }
          })
          .flat()
      })
      .flat() || []

  return fieldsData
}
